// Mirrors CONTACT_ROLE_VALUES in backend/payload/enums. Kept as a local list because
// the generated API client types roles as plain strings, so there is nothing to
// enumerate from. Order here is the order shown in the role dropdown.
export const CONTACT_ROLES = [
  'case_manager',
  'legal_professional',
  'physician',
  'specialist_physician',
  'psychologist',
  'therapist',
  'nurse',
  'special_educator',
  'personal_assistant',
  'coordinator',
  'administrator',
  'relative',
  'other',
] as const

export type ContactRole = (typeof CONTACT_ROLES)[number]
